import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultation-edit',
  templateUrl: './consultation-edit.component.html',
  styleUrls: ['./consultation-edit.component.scss']
})
export class ConsultationEditComponent implements OnInit {
  h1 = 'Editar consulta';

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/consultation/consultation-edit/consultation-edit.component.ts